import { useMemo } from "react";
import { useParams, useNavigate, useMatch } from 'react-router-dom';
import queryString from 'query-string';

// Hook
export function useRouter() {

  const params = useParams();
  //const location = useLocation();
  //const history = useHistory();
  const navigate = useNavigate();
  //const match = useRouteMatch<any>();
  const match = useMatch<any, any>("");

  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {
    return {
      // For convenience add push(), replace(), pathname at top level
      //push: history.push,
      //replace: history.replace,
      pathname: "",
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        ...queryString.parse(""), // Convert string to object
        ...params
      },
      // Include match, location, history objects so we have
      // access to extra React Router functionality if needed.
      match,
      navigate
    };
  }, [params, match, navigate]);
}

export default useRouter